import moment from 'moment';
import React from 'react';

import TwitterFollowButton from '../../pages/ui/_TwitterFollowButton';

const mutedColor = '#848484';

const styles = {
  coverWrapper: {
    maxWidth: '100%',
    marginTop: 0,
    position: 'relative',
    maxHeight: 460,
    overflow: 'hidden',
    backgroundColor: '#eee',
  },
  cover: {
    maxHeight: 480,
    lineHeight: 0,
  },
  coverImage: {
    width: '100%',
    top: 0,
    position: 'relative',
  },
  meta: {
    color: mutedColor,
    fontSize: '13px',
    textTransform: 'uppercase',
    marginBottom: '0.3em',
    fontWeight: 300,
    letterSpacing: '1px',
  },
  metaDetails: {
    display: 'inline',
    fontSize: '13px',
    fontStyle: 'normal',
  },
  metaLink: {
    border: 0,
    color: mutedColor,
    textDecoration: 'none',
  },
  muted: {
    color: mutedColor,
  },
  address: {
    borderTop: '1px solid #ddd',
    borderBottom: '1px solid #ddd',
    paddingTop: '1.5em',
    paddingBottom: '1.5em',
    margin: '20px 0',
    display: 'flex',
  },
  addressImage: {
    borderRadius: '50%',
    width: 64,
    height: 64,
    margin: '0 20px 0 0',
  },
  addressLink: {
    textDecoration: 'none',
  },
  addressText: {
    margin: 0,
    flex: 1,
  },
  addressFollow: {
    margin: '1em 0 0',
  },
};

export default class PostLayout extends React.Component {
  render() {
    const { post } = this.props;
    const author = post.author;
    const date = moment(post.date).locale('en');

    return (
      <article>
        {
          post.cover &&
            <div style={styles.coverWrapper}>
              <div style={styles.cover}>
                <img
                  style={styles.coverImage}
                  src={post.cover} />
              </div>
            </div>
        }
        <header>
          <div style={styles.meta}>
            By
            {' '}
            <address style={styles.metaDetails}>
              <a
                rel="author"
                href={author.link}
                title={author.name}
                target="_blank"
                style={styles.metaLink}>
                {author.name}
              </a>
            </address> &mdash;
            <time
              pubdate
              dateTime={date.toISOString()}
              style={styles.metaDetails}>
              {date.format('MMMM Do, YYYY')}
            </time>
          </div>
          <h1>{post.title}</h1>
        </header>
        <section dangerouslySetInnerHTML={{ __html: post.body }} />
        <address style={styles.address}>
          {
            author.image &&
              <img src={author.image} style={styles.addressImage} />
          }
          <div style={styles.addressText}>
            <div>
              Written by
              {' '}
              <strong>
                <a
                  rel="author"
                  href={`https://twitter.com/${author.twitter}`}
                  title={author.name}
                  target="_blank"
                  style={styles.addressLink}>
                  {author.name}
                </a>
              </strong>
            </div>
            <div style={styles.muted}>{author.bio}</div>
            <div style={styles.addressFollow}>
              <TwitterFollowButton username={author.twitter} />
            </div>
          </div>
        </address>
      </article>
    );
  }
}



/** WEBPACK FOOTER **
 ** ../wrappers/layouts/PostLayout.jsx
 **/